window.addEventListener('DOMContentLoaded', function(ev) {
    ev.preventDefault();
});
